import { defaultTheme, defaultLightTheme, defaultDarkTheme } from 'react-admin';
import { deepmerge } from '@mui/utils';

export const lightTheme = deepmerge(defaultTheme, {
    palette: {
        mode: 'light',
        background: {
            default: '#fafafa',
            paper: '#fff',
        },
        text: {
            primary: 'rgba(0, 0, 0, 0.87)',
            secondary: 'rgba(0, 0, 0, 0.54)',
            disabled: 'rgba(0, 0, 0, 0.38)',
            hint: 'rgba(0, 0, 0, 0.38)',
        },
        primary: {
            main: '#05924c',
            light: 'rgb(55, 167, 111)',
            dark: 'rgb(3, 102, 53)',
            contrastText: '#fff',
        },
        secondary: {
            main: '#fbbe0b',
            light: 'rgb(251, 203, 59)',
            dark: 'rgb(175, 133, 7)',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        error: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        warning: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        info: {
            main: '#079bdf',
            light: 'rgb(56, 175, 229)',
            dark: 'rgb(4, 108, 156)',
            contrastText: '#fff',
        },
        success: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        divider: 'rgba(0, 0, 0, 0.12)',
    },
});

export const darkTheme = deepmerge(defaultTheme, {
    palette: {
        mode: 'dark',
        background: {
            default: '#303030',
            paper: '#424242',
        },
        text: {
            primary: '#fff',
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            hint: 'rgba(255, 255, 255, 0.5)',
        },
        primary: {
            main: '#05924c',
            light: 'rgb(55, 167, 111)',
            dark: 'rgb(3, 102, 53)',
            contrastText: '#fff',
        },
        secondary: {
            main: '#fbbe0b',
            light: 'rgb(251, 203, 59)',
            dark: 'rgb(175, 133, 7)',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        error: {
            main: '#f44336',
            light: '#e57373',
            dark: '#d32f2f',
            contrastText: '#fff',
        },
        warning: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        info: {
            main: '#079bdf',
            light: 'rgb(56, 175, 229)',
            dark: 'rgb(4, 108, 156)',
            contrastText: '#fff',
        },
        success: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        divider: 'rgba(255, 255, 255, 0.12)',
    },
});
